import httpApi from '../api/httpApi';
import {
    CommentTemplate,
    CommentTemplateCreateProps,
} from '../../models/CommentTemplate';

const useCommentTemplates = () => {
    const COMMENT_TEMPLATE = '/api/v1/offers/templates/notes';

    const createCommentTemplate = (
        data: CommentTemplateCreateProps
    ): Promise<CommentTemplate> => {
        return httpApi
            .post<{ note: CommentTemplate }>(COMMENT_TEMPLATE, data)
            .then((resp) => {
                return resp.getData().note;
            });
    };

    const updateCommentTemplate = (id: number, data: CommentTemplateCreateProps) => {
        return httpApi
            .put<{ note: CommentTemplate }>(COMMENT_TEMPLATE + '/' + id, data)
            .then((resp) => {
                return resp.getData().note;
            });
    };

    const deleteCommentTemplate = (id: number): Promise<null> => {
        return httpApi.del<null>(COMMENT_TEMPLATE + '/' + id).then((resp) => {
            return resp.getData();
        });
    };

    return {
        createCommentTemplate,
        deleteCommentTemplate,
        updateCommentTemplate,
    };
};

export default useCommentTemplates;
